import React, { FunctionComponent } from 'react';
import { CalculatorBuyerCostsResultData } from './types';

interface CalculatorBuyerCostsCtaProps {
  result: CalculatorBuyerCostsResultData | Record<string, string>;
}

export const CalculatorBuyerCostsSummary: FunctionComponent<CalculatorBuyerCostsCtaProps> = ({
  result
}) => {
  if (!result) {
    return null;
  }

  return (
    <div className={`mb-8`}>
      <div>
        Je geeft aan dat {result.withPartner ? 'jullie' : 'je'} een{' '}
        <span className={`underline font-bold`}>
          {result.isNewConstruction ? 'nieuwbouw' : 'bestaande'}
        </span>{' '}
        woning kopen van <span className={`underline font-bold`}>{result.housePrice}</span>.
      </div>
      <div>
        <div>
          Jij bent {result.applicantAgeUnder35 ? 'jonger' : 'ouder'} dan{' '}
          <span className={`underline font-bold`}>35 jaar</span>.
        </div>
        {result.withPartner && (
          <>
            Jouw partner is {result.partnerAgeUnder35 ? 'jonger' : 'ouder'} dan{' '}
            <span className={`underline font-bold`}>35 jaar.</span>
          </>
        )}
      </div>
      <div>
        Jij hebt{' '}
        <span className={`underline font-bold`}>
          {result.applicantTransferTaxExemptionUsed ? 'wel' : 'geen'}
        </span>{' '}
        gebruik gemaakt van de startersvrijstelling.{' '}
        {result.withPartner && (
          <>
            Jouw partner heeft{' '}
            <span className={`underline font-bold`}>
              {result.partnerTransferTaxExemptionUsed ? 'wel' : 'geen'}
            </span>{' '}
            gebruik gemaakt van de startersvrijstelling.
          </>
        )}
      </div>
    </div>
  );
};
